module.exports = __webpack_public_path__ + "img/gleam_xl.dda3247.webp";